import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("apiToken");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    const status = error.response?.status;
    const detail = error.response?.data?.detail;
    const url = error.config?.url || "";
    const expired = ["Session expired", "Token expired", "Invalid token"].includes(detail);
    if (status !== 401 || url.includes("/auth/login") || url.includes("/auth/me")) return Promise.reject(error);
    if (expired && localStorage.getItem("apiToken")) window.dispatchEvent(new Event("session-expired"));
    // App is redirecting to /login — park the promise so page callers don't surface errors.
    return new Promise(() => {});
  },
);

export default api;

export const formatDetail = (detail) => {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};
